/**
 * useKnownEtfs — owns the fetch + refresh of the "ETF già nel database"
 * catalogue shown in the selection panel.
 *
 * `/api/known-etfs` is gated, so the fetch waits for an account that is
 * actually allowed to read it: firing early returns 401 and would leave the
 * catalogue silently empty. Subscribing to the auth context also re-runs the
 * fetch after a login without needing a page reload.
 */
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useKnownEtfs() {
  const [knownEtfs, setKnownEtfs] = useState([]);
  const [selectedEtfs, setSelectedEtfs] = useState([]);
  const { isActive } = useAuth();

  const refreshKnownEtfs = useCallback(() => {
    if (!isActive) return;
    axios.get(`${API}/known-etfs`)
      .then(({ data }) => setKnownEtfs(data.etfs))
      .catch(() => { /* non-fatal — sidebar simply shows empty list */ });
  }, [isActive]);

  useEffect(() => { refreshKnownEtfs(); }, [refreshKnownEtfs]);

  return { knownEtfs, selectedEtfs, setSelectedEtfs, refreshKnownEtfs };
}
